import React from 'react'
import { Box, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography } from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import { router, usePage } from '@inertiajs/react'
import AppShell from '../../../../components/layout/AppShell'
import PageHeader from '../../../../components/ui/PageHeader'
import StatusBadge from '../../../../components/ui/StatusBadge'

Index.layout = (page) => <AppShell>{page}</AppShell>

export default function Index({ property, settlements }) {
  const { props } = usePage()
  const tenant = props.tenant || {}
  const basePath = `/m/${tenant.slug}/properties/${property.id}`

  return (
    <Box>
      <PageHeader
        title="Hausgeldabrechnungen"
        breadcrumbs={[
          { label: property.name, href: basePath },
          { label: 'Hausgeldabrechnungen' },
        ]}
        actions={
          <Button variant="contained" size="small" startIcon={<AddIcon />}
            onClick={() => router.visit(`${basePath}/settlements/new`)}
            data-testid="new-settlement-btn"
          >
            Neue Abrechnung
          </Button>
        }
      />

      <TableContainer component={Paper} elevation={0} sx={{ border: '1px solid', borderColor: 'divider' }}>
        <Table size="small">
          <TableHead>
            <TableRow sx={{ backgroundColor: 'background.subtle' }}>
              <TableCell sx={{ fontWeight: 600 }}>Name</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Geschäftsjahr</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Abrechnungsart</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {settlements.length === 0 && (
              <TableRow>
                <TableCell colSpan={4} align="center" sx={{ py: 4 }}>
                  <Typography color="text.secondary">Keine Abrechnungen vorhanden.</Typography>
                </TableCell>
              </TableRow>
            )}
            {settlements.map((s) => (
              <TableRow key={s.id} hover sx={{ cursor: 'pointer' }}
                onClick={() => router.visit(`${basePath}/settlements/${s.id}`)}
              >
                <TableCell>{s.name}</TableCell>
                <TableCell>{s.fiscal_year_label}</TableCell>
                <TableCell>{s.settlement_type}</TableCell>
                <TableCell><StatusBadge type="settlement_status" value={s.status} /></TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  )
}
